import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  `ui-inline-flex ui-items-center ui-justify-center ui-whitespace-nowrap ui-rounded-lg ui-text-sm ui-font-semibold ui-ring-offset-background ui-transition-colors focus-visible:ui-outline-none focus-visible:ui-ring-2 focus-visible:ui-ring-ring focus-visible:ui-ring-offset-2 disabled:ui-pointer-events-none disabled:ui-cursor-not-allowed`,
  {
    variants: {
      variant: {
        primary: `ui-btn-primary`,
        secondary: `ui-btn-secondary`,
        destructive: `ui-btn-destructive`,
        outline: `ui-btn-primary-outline`,
        ghost: `ui-btn-ghost`,
        link: `ui-btn-link`
      },
      size: {
        sm: `ui-h-8 min-w-8 ui-px-3 py-1`,
        // md: `ui-h-10 min-w-10 ui-px-4 ui-py-2`,
        md: `ui-h-10 ui-px-4 ui-py-2`,
        lg: `ui-h-12 min-w-12 ui-px-4 ui-py-3`,
        xl: `ui-h-14 min-w-14 ui-px-6 ui-py-4`
      }
    },
    defaultVariants: {
      variant: `primary`,
      size: `lg`
    }
  }
)
